import {pipeHandlers} from 'utils/reduxEffects';
import common from './common/handler';
import reports from './reportsPage/handler';
import report from './reportPage/handler';
import trackingForms from './trackingFormsPage/handler';

export default pipeHandlers(common, reports, report, trackingForms);
